export const MESSAGES = {
  NOT_AUTHRIZED:
    'Você não tem permissão para acessar este recurso. Contacte o administrador do portal.',
  NOT_FOUND: 'Página não encontrada!',
};

export const SKW_URL = getSkwUrl();
export const SKW_AUTH = getSkwAuth();
export const SKW_PREFIX = getSkwPrefix();

// Base Produção
function getSkwUrl() {
  if (window['REACT_APP_SKW_URL']) {
    return `${window['REACT_APP_SKW_URL']}/`;
  }
  // return 'http://192.168.254.100:8080/udinick'; // interno

  // return 'http://138.185.109.230:8080/udinick'; // externo

  return 'http://sankhya.kothe.com.br:8080/udinick'; //produção

  // return 'http://192.168.242.225:8080/udinick'; // vpn produção
}

function getSkwAuth() {
  if (window['REACT_APP_SKW_AUTH']) {
    return `${window['REACT_APP_SKW_AUTH']}`;
  }
  return 'a202df75-052d-43ab-b961-c6c8b3001713';
}

function getSkwPrefix() {
  if (window['REACT_APP_SKW_PREFIX']) {
    return `${window['REACT_APP_SKW_PREFIX']}`;
  }
  return '';
}
